export default __webpack_public_path__ + "static/media/one-mini.29e4d707.mp4";